var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#D0E0E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5H16.1686C16.2909 11.5 16.3521 11.5 16.4096 11.5138C16.4606 11.5261 16.5094 11.5463 16.5541 11.5737C16.6046 11.6046 16.6478 11.6478 16.7343 11.7343L18.7657 13.7657C18.8522 13.8522 18.8954 13.8954 18.9263 13.9459C18.9537 13.9906 18.9739 14.0394 18.9862 14.0904C19 14.1479 19 14.2091 19 14.3314V15.75C19 15.983 19 16.0995 18.9619 16.1913C18.9112 16.3139 18.8139 16.4112 18.6913 16.4619C18.5995 16.5 18.483 16.5 18.25 16.5M15.75 16.5H15M15 16.5V11.6C15 11.0399 15 10.7599 14.891 10.546C14.7951 10.3578 14.6422 10.2049 14.454 10.109C14.2401 10 13.9601 10 13.4 10H10.6C10.0399 10 9.75992 10 9.54601 10.109C9.35785 10.2049 9.20487 10.3578 9.10899 10.546C9 10.7599 9 11.0399 9 11.6V15.5C9 16.0523 9.44772 16.5 10 16.5M15 16.5H13M13 16.5C13 17.3284 12.3284 18 11.5 18C10.6716 18 10 17.3284 10 16.5M13 16.5C13 15.6716 12.3284 15 11.5 15C10.6716 15 10 15.6716 10 16.5M18.25 16.75C18.25 17.4404 17.6904 18 17 18C16.3096 18 15.75 17.4404 15.75 16.75C15.75 16.0596 16.3096 15.5 17 15.5C17.6904 15.5 18.25 16.0596 18.25 16.75Z",
    stroke: "#45748C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadIcon);
export default __webpack_public_path__ + "static/media/roadIcon.020bd731d02b09c06bcc030f9f16952c.svg";
export { ForwardRef as ReactComponent };